import clsx from 'clsx';

interface AuthContactFooterProps {
  readonly compact?: boolean;
}

export function AuthContactFooter({ compact = false }: AuthContactFooterProps) {
  return (
    <p
      className={clsx(
        'text-center text-gray-500',
        compact ? 'text-xs leading-tight' : 'pt-0.5 text-sm',
      )}
    >
      Need help?{' '}
      <a
        href="mailto:contact@marchemy.com"
        className="font-medium text-primary-500 hover:underline"
      >
        Contact us
      </a>
    </p>
  );
}
